import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import { compose } from 'recompose';
import classNames from 'classnames';

import withUrlGenerator from '../../lib/withUrlGenerator';
import withTranslations from '../../lib/withTranslations';

const propTypes = {
    urlGenerator: PropTypes.shape({
        route: PropTypes.func,
    }).isRequired,
    t: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }).isRequired,
};

const defaultProps = {

};

const Header = ({ urlGenerator, t, locale, location }) => (
    <div
        className={classNames({
            header: true,
            white: location.pathname === urlGenerator.route('info'),
        })}
    >
        <Link to={urlGenerator.route('home')} className="close">X</Link>
        <div className="inner">
            <div className="menu horizontal">
                <ul>
                    <li>
                        <Link to={urlGenerator.route('info')}>{t('info')}</Link>
                    </li>
                </ul>
            </div>
            <div className="menu horizontal right">
                <ul>
                    <li>
                        <a href={urlGenerator.route(`home.${locale === 'en' ? 'fr' : 'en'}`)}>
                            {locale === 'en' ? 'Fr' : 'En'}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
);

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

const enhancer = compose(
    withUrlGenerator(),
    withTranslations(),
    withRouter,
);
export default enhancer(Header);



// WEBPACK FOOTER //
// ./components/partials/Header.jsx